import { type IssueAttachment } from "@overmap-ai/common"
import { selectIssueAttachmentById } from "@overmap-ai/core"
import type { NodeViewProps } from "@tiptap/react"
import { memo } from "react"

import { sdk } from "../../../sdk"
import { useAppSelector } from "../../../store"
import { BaseAttachmentNodeComponent } from "../BaseAttachment/Component"
import { NotFoundAttachmentNode } from "../BaseAttachment/FallbackAttachmentNode"

export const IssueAttachmentNodeComponent = memo((props: NodeViewProps) => {
	const { node } = props
	const attachmentId = node.attrs.uuid as string
	const issueAttachment = useAppSelector(selectIssueAttachmentById(attachmentId))

	if (!issueAttachment) {
		return <NotFoundAttachmentNode {...props} />
	}

	return (
		<BaseAttachmentNodeComponent<IssueAttachment>
			attachment={issueAttachment}
			service={sdk.issueAttachments}
			{...props}
		/>
	)
})
IssueAttachmentNodeComponent.displayName = "IssueAttachmentNodeComponent"
